import { navigate } from 'gatsby'
import React, { useEffect, useState } from 'react'
import { SidebarGlobalProps } from '../../Sidebar/types'
import { MultiLevelChild } from './MultiLevelChild/MultiLevelChild'
import { MultiLevelCollapse } from './MultiLevelCollapse/MultiLevelCollapse'

interface MultiLevelProps {
  title: string
  url: string
  children: SidebarGlobalProps[]
  countrySelection: string
  amplitude: string
}

export const MultiLevel: React.FC<MultiLevelProps> = ({
  title,
  url,
  children,
  countrySelection,
  amplitude,
}) => {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    url
      ? navigate(url, { replace: false })
      : navigate(children[0].url!, { replace: false })
    setOpen((prev) => !prev)
  }

  let activeCountry = countrySelection

  if (countrySelection === 'GB') {
    activeCountry = 'UK'
  }

  const isPathMatching = (elements: any) => {
    elements.map((element: any) => {
      if (element.url === window.location.pathname) setOpen(true)
      if (element.children) isPathMatching(element.children)
    })
  }

  useEffect(() => {
    if (url === window.location.pathname) {
      setOpen(true)
    }

    isPathMatching(children)
  }, [])

  if (
    title.includes('Pay Later Offers') &&
    title !== `Pay Later Offers (${activeCountry})`
  ) {
    return null
  }

  return (
    <>
      <MultiLevelCollapse
        activeCountry={activeCountry}
        onClick={handleClick}
        url={url}
        title={title}
        isExpanded={open}
        amplitude={amplitude}
      />

      {open && <MultiLevelChild data={children} />}
    </>
  )
}

MultiLevel.displayName = 'MultiLevel'
